<div class="d-flex mx-0 flex-column flex-md-row justify-contet-between p-white border-bottom secondaryMenu px-4 py-3">
    <div class="d-flex flex-column col">
        <h3 class="mt-0 mb-1">Create Job Requests</h3>
        <p-breadcrumb [model]="items"></p-breadcrumb>
    </div>
    <div class="d-flex justify-content-start justify-content-md-end col mt-2 mt-md-0">
        <button pButton pRipple type="button" label="Discard Request" class="p-button-outlined p-button-danger me-3"></button>
        <button pButton pRipple type="button" label="Save Request" class="p-button-outlined me-3"></button>
        <button pButton type="button" icon="pi pi-check" label="Send Request" iconPos="left"></button>
    </div>
</div>

<div class="row mx-0">
    <div class="col-12 col-sm-12 col-md-4 col-lg-3 px-0">
        <div class="m-3 p-white shadow-sm bg-aqua p-3">
            <h4 class="mt-0 mb-4">Select Template</h4>
            <div class="d-flex flex-column mb-4">
                <label class="mb-2">Company Name</label>
                <p-dropdown placeholder="Select Company Name"  optionLabel="name"></p-dropdown>
            </div>
            <div class="d-flex flex-column mb-4">
                <label class="mb-2">Operation</label>
                <p-dropdown placeholder="Select Operation"  optionLabel="name"></p-dropdown>
            </div>
            <div class="d-flex flex-column mb-4">
                <label class="mb-2">Transaction</label>
                <p-dropdown placeholder="Select Transaction"  optionLabel="name"></p-dropdown>
            </div>
            <div class="d-flex flex-column mb-4">
                <label class="mb-2">Budget</label>
                <p-dropdown placeholder="Select Template"  optionLabel="name"></p-dropdown>
            </div>
        </div>
    </div>
    <div class="col-12 col-sm-12 col-md-4 col-lg-6 px-0">
        <div class="m-3 p-white shadow-sm bg-aqua p-3">
            <div class="mb-3">
                <h4 class="my-0">Office Running Charges - Request</h4>
                <p class="p-text-secondary mb-0 mt-2">Use this form for office running charges</p>
            </div>
            <div class="row mb-4">
                <div class="col-12 col-sm-12">
                    <div class="row">
                        <div class="col-12 col-sm-12 col-md-6 mb-lg-0 mb-md-4">
                            <div class="d-flex flex-column">
                                <label class="mb-2">Date</label>
                                <input type="text" pInputText> 
                            </div>
                        </div>
                        <div class="col-12 col-sm-12 col-md-6 mb-lg-0 mb-md-4">
                            <div class="d-flex flex-column">
                                <label class="mb-2">Name</label>
                                <input type="text" pInputText> 
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="row mb-4">
                <div class="col-12 col-sm-12">
                    <div class="d-flex flex-column">
                        <label class="mb-2">Job Value</label>
                        <input type="text" pInputText> 
                    </div>
                </div>
            </div>
            <div class="row mb-4">
                <div class="col-12 col-sm-12">
                    <div class="d-flex flex-column">
                        <label class="mb-2">Payee</label>
                        <p-dropdown placeholder="Select Payee"  optionLabel="name"></p-dropdown>
                    </div>
                </div>
            </div>
            <div class="row mb-4">
                <div class="col-12 col-sm-12">
                    <div class="d-flex flex-column">
                        <label class="mb-2">Remarks</label>
                        <input type="text" pInputText> 
                    </div>
                </div>
            </div>
            <div class="row mb-4">
                <div class="col-12 col-sm-12">
                    <p-fileUpload name="myfile[]"></p-fileUpload>
                </div>
            </div>
        </div>
    </div>

    <div class="col-12 col-sm-12 col-md-4 col-lg-3 px-0">
        <div class="m-3 p-white shadow-sm p-3">
            <h4 class="mt-0 mb-4">Job Chain</h4>

            <p-timeline [value]="events1" align="left" styleClass="customized-timeline">
                <ng-template pTemplate="marker" let-event>
                    <span class="custom-marker p-shadow-2">
                        <div [ngClass]="event.iconclass" ></div>
                    </span>
                </ng-template>
                <ng-template pTemplate="content" let-event>
                    <div [ngClass]="event.class" class="p-3">
                        <p class="step-text mt-0 mb-0">Request Created.</p>
                        <p class="step-text mt-0 mb-0">2021 Auguts 21, 10:21 AM</p>
                    </div>
                        
                </ng-template>
            </p-timeline>
        </div>
    </div>
</div>
    
